import axios from 'axios';
import { UpdateFeedInput } from '../types/update-feed-input.type';

// PUT FEED
// /ewosapi/v1/shrimps/Feed/{globalCompanyId}/{feedId}
export const putFeed = async (globalCompanyId: string, feedId: number, request: UpdateFeedInput) => {
  const res = await axios.put(`/ewosapi/v1/shrimps/Feed/${globalCompanyId}/${feedId}`, request);
  return res.data;
};
